import * as highcharts from 'highcharts';
import highchartAnnotations from 'highcharts/modules/annotations';
import highchartAnnotationsAdvanced from 'highcharts/modules/annotations-advanced';
export { highcharts };

declare module 'highcharts'{
	export interface Axis{
		left:number;
		top:number;
		width:number;
		height:number;
	}

	export interface Point{
		refresh():void;
	}

	interface SVGElement{
		width:number;
		height:number;
	}

	interface AnnotationsOptions{
		custom?: Dictionary<any>;
	}

	interface AnnotationControlPointOptionsObjectEvents{
		mousedown?(this:Annotation.ControlPoint, evt:PointerEventObject, target:highcharts.Annotation.ControllableShape):void;
		drag?(this:Annotation.ControlPoint, evt:PointerEventObject, target:highcharts.Annotation.ControllableShape):void;
		mouseup?(this:Annotation.ControlPoint, evt:PointerEventObject, target:highcharts.Annotation.ControllableShape):void;
		dragend?(this:Annotation.ControlPoint, evt:PointerEventObject, target:highcharts.Annotation.ControllableShape):void;
	}

	interface AnnotationControlPointOptionsObject{
		events?:Dictionary<Function>;
		//events?:AnnotationControlPointOptionsObjectEvents;
	}
	
	type AnnotationControlPointOptions=AnnotationControlPointOptionsObject;

	export interface AnnotationsShapesOptions{
		controlPoints?:AnnotationControlPointOptions[];
	}

	export interface Annotation{
		setControlPointsVisibility(v:boolean):void;
		labels:Annotation.ControllableLabel[];
		shapes:Annotation.ControllableShape[];
	}

	interface AnnotationControllable{
		graphic:SVGElement;
		redraw(animation:boolean):void;
	}

	export interface AnnotationControlPoint{
		chart:Chart;
		index:number;
		target:any;
		options:any;

		graphic:highcharts.SVGElement;

		mouseMoveToTranslation(evt:PointerEventObject):{x:number,y:number};
	}

	export namespace Annotation{
		type ControlPoint=AnnotationControlPoint;
		const ControlPoint:typeof AnnotationControlPoint;

		const MockPoint:{
			new ():{};
			pointToPixels(point:highcharts.Point):{x:number,y:number};
		}
	
		interface ControllableLabel extends highcharts.AnnotationControllable{
		}

		interface ControllableBase extends highcharts.AnnotationControllable{
			type:string;
		}

		interface ControllableRect extends ControllableBase{
			type:'rect';
		}
		
		interface ControllableCircle extends ControllableBase{
			type:'circle';
		}

		interface ControllableEllipse extends ControllableBase{
			type:'ellipse';
		}

		interface ControllablePath extends ControllableBase{
			type:'path';
			translatePoint(dx:number, dy:number, i:number):void;
		}

		interface ControllableImage extends ControllableBase{
			type:'image';
		}


		type ControllableShape=ControllableRect|ControllableCircle|ControllableEllipse|ControllablePath|ControllableImage;

		// const shapesMap:{
		// 	// 'rect': ControllableRect,
		// 	// 'circle': ControllableCircle,
		// 	// 'ellipse': ControllableEllipse,
		// 	// 'path': ControllablePath,
		// 	// 'image': ControllableImage
		// }	
	}

	export interface Chart{
		annotations:Annotation[];
	}

}

highchartAnnotations(highcharts);
highchartAnnotationsAdvanced(highcharts);
